/**
 * Keyboard containment for the consent dialogs.
 *
 * Consent has to be given before the page can be used, so Tab must not walk
 * out of the dialog into content the visitor is not supposed to reach yet.
 */
const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(', ')

function focusableElements (container) {
  if (!container) {
    return []
  }

  return Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR))
    .filter(element => element.offsetParent !== null || element === document.activeElement)
}

/** Move focus into the dialog so screen readers and keyboards start there. */
export function focusFirst (container) {
  const elements = focusableElements(container)

  if (elements.length) {
    elements[0].focus()
  } else if (container) {
    container.focus()
  }
}

/** Keep Tab / Shift+Tab cycling inside `container`. */
export function trapTab (event, container) {
  if (event.key !== 'Tab') {
    return
  }

  const elements = focusableElements(container)

  if (!elements.length) {
    event.preventDefault()

    return
  }

  const first = elements[0]
  const last = elements[elements.length - 1]

  if (event.shiftKey && (document.activeElement === first || !container.contains(document.activeElement))) {
    event.preventDefault()
    last.focus()

    return
  }

  if (!event.shiftKey && (document.activeElement === last || !container.contains(document.activeElement))) {
    event.preventDefault()
    first.focus()
  }
}
